import AnalyticService from "../services/analytics.service";

export const analytics = {
  namespaced: true,
  actions: {
    get({ commit }) {
      return AnalyticService.get()
        .then(
          (analytic) => {
            return Promise.resolve(analytic);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .catch((e) => {
          return Promise.reject(e);
        });
    },
    getTypes({ commit }) {
      return AnalyticService.getTypes()
        .then(
          (socialMediaTypes) => {
            return Promise.resolve(socialMediaTypes);
          },
          (error) => {
            console.log('modeule getTypes', error);
            return Promise.reject(error);
          }
        )
        .catch((e) => {
          return Promise.reject(e);
        });
    }
  },
  mutations: {
  },
  getters: {
  },
};
